import React from 'react';

import { IFilterValueSelectorProps } from './interfaces';
import { Box } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import { parseIsoWithDefault } from '../../../utility/dateUtils';

export default function DateSelector({ filterValues, setFilterValues }: IFilterValueSelectorProps) {
  const setStart = (start: string | null) => setFilterValues([start, filterValues[1] ?? null]);
  const setEnd = (end: string | null) => setFilterValues([filterValues[0] ?? null, end]);

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 2 }}>
      <DatePicker label="Start Date" value={parseIsoWithDefault(filterValues[0])} onChange={(newDate) => setStart(newDate?.toISO() ?? null)} />
      <DatePicker label="End Date" value={parseIsoWithDefault(filterValues[1])} onChange={(newDate) => setEnd(newDate?.toISO() ?? null)} />
    </Box>
  );
}
